import { useMemo } from 'react';
import { useMedias } from '@divlab/divanui';

import Img from '@UI/Img';
import chunkArray from '@Utils/chunkArray';
import GallerySection from '@Components/GallerySection';
import styles from './Gallery.module.css';

import type { FC, HTMLAttributes } from 'react';

interface GalleryProps extends HTMLAttributes<HTMLDivElement> {
  gallery: GalleryData;
}

export type GalleryData = {
  title: string;
  description: string;
  images: string[];
};

const Gallery: FC<GalleryProps> = (props) => {
  const { gallery, ...restProps } = props;
  const { isDesktop, isMobile } = useMedias();

  const slides = useMemo(() => {
    let countInSlide = 6;
    if (isDesktop) countInSlide = 3;
    if (isMobile) countInSlide = 1;

    return chunkArray(gallery.images, countInSlide);
  }, [gallery.images, isDesktop, isMobile]);

  return (
    <GallerySection
      fullWidth
      cnGallery={styles.gallery}
      cnSlide={styles.slide}
      title={gallery.title}
      description={gallery.description}
      slides={slides}
      renderSlide={(slide) => (
        <div className={styles.grid}>
          {slide.map((image) => (
            <Img
              className={styles.imageWrapper}
              cnImage={styles.image}
              key={image}
              src={`https://divan.ru${image}`}
            />
          ))}
        </div>
      )}
      {...restProps}
    />
  );
};
export default Gallery;
